import {_, React, observer, observable, computed, action, useLocalStore, classNames, useAsObservableSource, utils} from '@api'
import {EditableText, Menu, MenuDivider, MenuItem} from '@blueprintjs/core'
import { TextField } from '@material-ui/core'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {VipFlexLayoutTabStore, useVipFlexLayoutTabStore} from '@stores/catalog/flexLayout'
import * as css from './TabGroupLabelMenuPanel.css'

export const ENTER = 13;
export const SHIFT = 16;
export const ESCAPE = 27;

/// region Store

export class TabGroupLabelMenuPanelStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: {tabStore: VipFlexLayoutTabStore}) {
    super(stores)
    this.originalName = props.tabStore.tab.name
  }

  @action toggleGroupExpanded = () => {
    this.tab.attributes.groupExpanded = !this.tab.attributes.groupExpanded
  }

  @action selectAllOnFocus = (e : React.FocusEvent<HTMLInputElement>) => {
    e.target.select()
  }

  @observable originalName


  @action onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.tab._setName(e.target.value)
  }

  @action onNameKeyPress = (e: React.KeyboardEvent) => {
    if (e.which === ESCAPE) {
      this.tab._setName(this.originalName)
    }
    else if (e.which === ENTER) {
      this.onConfirmName()
    }
  }

  @action onConfirmName = () => {
    this.originalName = this.tab.name
    this.tab.model._changeListener()
  }

  @computed get tab() { return this.props.tabStore.tab }

  @action selectColor = (c) => {
    this.tab.json.groupColor = c
  }

  @computed get colors() {
    return ['gray', 'blue', 'red', 'orange', 'green', 'pink', 'purple', 'teal']
  }

  @action deleteGroup = () => {
    this.flexLayout.deleteGroup(this.tab)
  }

  @action closeAllItemsInGroup = () => {
    this.flexLayout.closeAllItemsInGroup(this.tab)
  }

  @action newTabInGroup = () => {
    this.flexLayout.newTabInGroup(this.tab)
  }

  @action moveToNewWindow = () => {
    this.flexLayout.moveToNewWindow(this.tab)
  }
}

export const TabGroupLabelMenuPanelStoreContext = React.createContext<TabGroupLabelMenuPanelStore>(null)
export const useTabGroupLabelMenuPanelStore = () => React.useContext(TabGroupLabelMenuPanelStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const TabGroupLabelMenuPanel = observer<MyProps>(function TabGroupLabelMenuPanel({className, ...props}) {
  const tabStore = useVipFlexLayoutTabStore(),
    obsProps = useAsObservableSource({tabStore}),
    store = useVipLocalStore((stores) => new TabGroupLabelMenuPanelStore(stores, obsProps)),
    {tab, colors, selectAllOnFocus, toggleGroupExpanded, onChangeName, onConfirmName, onNameKeyPress, selectColor, deleteGroup, closeAllItemsInGroup, newTabInGroup, moveToNewWindow} = store

  return (
    <TabGroupLabelMenuPanelStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <div className={css.column}>
          <TextField onFocus={selectAllOnFocus} variant='outlined' color='secondary' className={css.name} value={tab.name} onKeyPress={onNameKeyPress} onBlur={onConfirmName} onChange={onChangeName} />
          <div className={css.colorSwatches}>
            {colors.map((c, i) => <div className={css.colorSwatch} key={i} style={{'--swatch-color': c} as any} data-selected={c === tab.groupColor} onClick={e => selectColor(c)} /> )}
          </div>
        </div>

        <Menu>
          <MenuItem shouldDismissPopover={false} icon={tab.groupExpanded ? 'tick' : 'blank'} text='Expand Group' onClick={toggleGroupExpanded}/>
          <MenuDivider />
          <MenuItem text='New Tab in Group' onClick={newTabInGroup} />
          <MenuItem text='Ungroup' onClick={deleteGroup}/>
          <MenuItem text='Close All Items in Group' onClick={closeAllItemsInGroup}/>
          <MenuItem text='Move Group to New Window' onClick={moveToNewWindow}/>
        </Menu>
      </div>
    </TabGroupLabelMenuPanelStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/TabGroupLabelMenuPanel.tsx